module.exports = __webpack_public_path__ + "static/media/50014.7a38e95d.png";